export const queryKeys = {
  vendor: {
    settings: () => ['vendor', 'settings'],
    me: () => ['vendor', 'me'],
  },
  orders: {
    comments: (orderId) => ['orders', String(orderId), 'comments'],
    commentMentionables: (orderId, channel) => ['orders', String(orderId), 'comments', 'mentionables', channel],
    phases: (orderId) => ['orders', String(orderId), 'phases'],
  },
  phases: {
    templates: () => ['phases', 'templates'],
  },
  notifications: {
    unreadCount: () => ['notifications', 'unread-count'],
    list: (perPage = 10, page = 1) => ['notifications', 'list', perPage, page],
  },
  support: {
    unreadCount: () => ['support', 'unread-count'],
  },
};
